import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { FormattedMessage, injectIntl } from 'react-intl';

import { black2, evisortBlue } from '../../../assets/shared-styles/general';
import { MODAL_LIST } from '../../../types/modal.types';
import { SUCCESS, WARNING } from '../../../types/toast.types';
import {
  editDocumentRelationshipGroup,
  linkParentChildDocumentsInGroup,
} from '../../DocumentGroupsPage/DocumentGroupsPage.data';
import { documentTypeIcon } from '../../DocumentsPage/Document.utils';
import EcModal from '../../Shared/EcModal/EcModal';
import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import EcRadioButton from '../../Shared/EcRadioButton/EcRadioButton';
import EcRadioContainer from '../../Shared/EcRadioContainer/EcRadioContainer';
import { showToast } from '../../Shared/EcToast/showToast';
import ChevronRightIcon from '../../Shared/Icons/ChevronRightIcon';
import styles from './DocumentGroupRelationModal.styles';

class DocumentGroupRelationModal extends Component {
  constructor(props) {
    super(props);

    this.handleAddListItem = this.handleAddListItem.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleActionClick = this.handleActionClick.bind(this);

    this.state = {
      selectedOption: this.props.selectedDocument.node.relationship,
      documentSelected: null,
      selectedDocumentPCRelationOption: 'linkAsChild',
    };
  }

  handleOptionSelection(selectedOption) {
    this.setState({ selectedOption });
  }

  handleDocumentPCRelationSelection(selectedDocumentPCRelationOption) {
    this.setState({ selectedDocumentPCRelationOption });
  }

  handleShowModal(modal) {
    this.setState({
      primaryModal: modal,
    });
  }

  handleHideModal() {
    this.setState({ primaryModal: null });
  }

  handleAddListItem(documentSelected) {
    this.setState({ documentSelected });
  }

  handleActionClick() {
    const {
      selectedDocument,
      groupId,
      hideModal,
      reloadDocumentTreeData,
      intl,
    } = this.props;
    const {
      selectedOption,
      documentSelected,
      selectedDocumentPCRelationOption,
    } = this.state;

    if (selectedOption === 'uncategorized' || selectedOption === 'supporting') {
      const data = { relationship: selectedOption };
      editDocumentRelationshipGroup(selectedDocument.node.docGroupId, data)
        .then(() => {
          hideModal();
          showToast(
            SUCCESS,
            intl.formatMessage({
              id: 'DocumentGroupRelationModal.documentUpdatedSuccess',
              defaultMessage: 'Document has been updated.',
              description: 'Success message for document update',
            }),
          );
          reloadDocumentTreeData();
        })
        .catch(() =>
          showToast(
            WARNING,
            intl.formatMessage({
              id: 'DocumentGroupRelationModal.updateError',
              defaultMessage:
                'An error occurred while updating the document relationship.',
              description:
                'Error message for document relationship update failure',
            }),
          ),
        );
    } else {
      const data =
        selectedDocumentPCRelationOption === 'linkAsChild'
          ? {
              parent: documentSelected.documentId,
              child: selectedDocument.node.documentId,
            }
          : {
              child: documentSelected.documentId,
              parent: selectedDocument.node.documentId,
            };
      linkParentChildDocumentsInGroup(groupId, data)
        .then(() => {
          hideModal();
          showToast(
            SUCCESS,
            intl.formatMessage({
              id: 'DocumentGroupRelationModal.documentsLinkedSuccess',
              defaultMessage: 'Documents have been linked.',
              description: 'Success message for document linking',
            }),
          );
          reloadDocumentTreeData();
        })
        .catch(() => {
          hideModal();
          showToast(
            WARNING,
            intl.formatMessage({
              id: 'DocumentGroupRelationModal.linkingError',
              defaultMessage:
                'An error occurred while updating the document relationship.',
              description: 'Error message for document linking failure',
            }),
          );
        });
    }
  }

  renderDocumentRelationOptions() {
    const { classes, intl } = this.props;
    const { selectedOption } = this.state;

    return (
      <EcRadioContainer
        groupName="documentRelationOptions"
        onChange={({ selectedValue }) =>
          this.handleOptionSelection(selectedValue)
        }
        defaultValue={selectedOption}
      >
        {(groupName, selectedValue, onOptionChange) => (
          <div className={classes.radioContainerContent}>
            <EcRadioButton
              id="uncategorized"
              groupName="documentRelationOptions"
              value="uncategorized"
              label={intl.formatMessage({
                id: 'DocumentGroupRelationModal.uncategorizedOption',
                defaultMessage: 'Uncategorized',
                description: 'Label for uncategorized option',
              })}
              onChange={onOptionChange}
              selectedValue={selectedOption}
              labelColor={black2}
            />

            <EcRadioButton
              id="linkToDocument"
              groupName="documentRelationOptions"
              value="linked"
              label={intl.formatMessage({
                id: 'DocumentGroupRelationModal.linkToDocumentOption',
                defaultMessage: 'Link to Document',
                description: 'Label for link to document option',
              })}
              onChange={onOptionChange}
              selectedValue={selectedOption}
              labelColor={black2}
            />

            {selectedOption === 'linked' && this.renderPickADocumentLink()}

            <EcRadioButton
              id="supportingDocument"
              groupName="documentRelationOptions"
              value="supporting"
              label={intl.formatMessage({
                id: 'DocumentGroupRelationModal.supportingDocumentOption',
                defaultMessage: 'Supporting Document',
                description: 'Label for supporting document option',
              })}
              onChange={onOptionChange}
              selectedValue={selectedOption}
              labelColor={black2}
            />
          </div>
        )}
      </EcRadioContainer>
    );
  }

  renderDocumentPCRelationOptions() {
    const { classes, intl } = this.props;
    const { selectedDocumentPCRelationOption, documentSelected } = this.state;

    if (!documentSelected) return null;
    return (
      <>
        <div className={classes.relationshipLabel}>
          <FormattedMessage
            id="DocumentGroupRelationModal.relationshipLabel"
            defaultMessage="RELATIONSHIP"
            description="Label for relationship section"
          />
        </div>
        <EcRadioContainer
          groupName="documentPCRelationOptions"
          onChange={({ selectedValue }) =>
            this.handleDocumentPCRelationSelection(selectedValue)
          }
          defaultValue={selectedDocumentPCRelationOption}
        >
          {(groupName, selectedValue, onOptionChange) => (
            <div className={classes.radioContainerContent}>
              <EcRadioButton
                id="linkAsChild"
                isInline={true}
                groupName="documentPCRelationOptions"
                value="linkAsChild"
                label={intl.formatMessage({
                  id: 'DocumentGroupRelationModal.linkAsChildOption',
                  defaultMessage: 'Link as Child',
                  description: 'Label for link as child option',
                })}
                onChange={onOptionChange}
                selectedValue={selectedDocumentPCRelationOption}
                fontSize="13px"
                labelColor={black2}
              />

              <EcRadioButton
                id="linkAsParent"
                isInline={true}
                groupName="documentPCRelationOptions"
                value="linkAsParent"
                label={intl.formatMessage({
                  id: 'DocumentGroupRelationModal.linkAsParentOption',
                  defaultMessage: 'Link as Parent',
                  description: 'Label for link as parent option',
                })}
                onChange={onOptionChange}
                selectedValue={selectedDocumentPCRelationOption}
                fontSize="13px"
                labelColor={black2}
              />
            </div>
          )}
        </EcRadioContainer>
      </>
    );
  }

  renderDoumentListModal() {
    const { groupData, intl } = this.props;

    return (
      <EcModal
        modalType={MODAL_LIST}
        width="560px"
        title={intl.formatMessage({
          id: 'DocumentGroupRelationModal.pickDocumentTitle',
          defaultMessage: 'Pick a Document',
          description: 'Title for pick document modal',
        })}
        listItems={groupData}
        selectedItemIds={[]}
        returnListItem={this.handleAddListItem}
        hideModal={this.handleHideModal}
      />
    );
  }

  renderPickADocumentLink() {
    const { classes } = this.props;
    const { documentSelected } = this.state;

    return (
      <div className={classes.pickADocument}>
        {documentSelected ? (
          <div className={classes.documentSelectedDisplay}>
            <span>{documentTypeIcon(documentSelected.fileType)}</span>
            {documentSelected.label}
          </div>
        ) : (
          <div className={classes.lightText}>
            <FormattedMessage
              id="DocumentGroupRelationModal.noDocumentSelected"
              defaultMessage="You haven't selected a document to link to."
              description="Message when no document is selected"
            />
          </div>
        )}
        <div>
          <button
            className={classes.selectDocumentCTA}
            onClick={() => this.handleShowModal(MODAL_LIST)}
          >
            <ChevronRightIcon size="15" color={evisortBlue} />
            <FormattedMessage
              id="DocumentGroupRelationModal.pickDocumentButton"
              defaultMessage="Pick a document"
              description="Button text to pick a document"
            />
          </button>
        </div>
        {this.renderDocumentPCRelationOptions()}
      </div>
    );
  }

  render() {
    const { classes, title, hideModal, intl } = this.props;
    const { selectedOption, documentSelected, primaryModal } = this.state;
    const disableSaveButton = selectedOption === 'linked' && !documentSelected;

    const cancelText = intl.formatMessage({
      id: 'DocumentGroupRelationModal.cancelButton',
      defaultMessage: 'Cancel',
      description: 'Cancel button text',
    });

    return (
      <>
        <EcModalCard
          title={title}
          content={
            <div className={classes.modalBody}>
              <div className={classes.modalBodyContent}>
                <div className={classes.headerText}>
                  <FormattedMessage
                    id="DocumentGroupRelationModal.headerText"
                    defaultMessage="Specify the relationship between this document and other documents in the group."
                    description="Header text explaining document relationships"
                  />
                </div>
                {this.renderDocumentRelationOptions()}
              </div>
            </div>
          }
          footer={
            <>
              {selectedOption === 'existingGroup' ? (
                <Button
                  variant="tertiary"
                  text={cancelText}
                  onClick={hideModal}
                />
              ) : (
                <>
                  <Button
                    variant="tertiary"
                    text={cancelText}
                    onClick={hideModal}
                  />
                  <Button
                    variant="primary"
                    text={intl.formatMessage({
                      id: 'DocumentGroupRelationModal.saveButton',
                      defaultMessage: 'Save',
                      description: 'Save button text',
                    })}
                    disabled={disableSaveButton}
                    onClick={this.handleActionClick}
                  />
                </>
              )}
            </>
          }
          hideModal={hideModal}
        />
        {primaryModal === MODAL_LIST && this.renderDoumentListModal()}
      </>
    );
  }
}

DocumentGroupRelationModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  labelText: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
};

export default injectIntl(injectSheet(styles)(DocumentGroupRelationModal));
